import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './KbdGroup.css'

/**
 * Kbd Group lays out a set of [Kbd](/components/kbd/) keys together, for example
 * to represent a multi-key shortcut such as <kbd>Ctrl</kbd> <kbd>K</kbd>.
 *
 * @status ready
 * @category content
 * @lightDom true
 *
 * @slot - Default slot for [Kbd](/components/kbd/) elements.
 */
@customElement('nord-kbd-group')
export default class KbdGroup extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-kbd-group': KbdGroup
  }
}
